import CopyButton from "@/components/CopyButton";
import PageBack from "@/components/PageBack";
import RpIcon from "@/components/RpIcon";
import API from "@/constant/API";
import RouteConstant from "@/constant/RouteConstant";
import axiosInstance from "@/utils/axios";
import { getIconByBizType, getResourceByMcc, getResourceByMccName, getUrlParams } from "@/utils/utils.js";
import { Box, Divider, Stack, Typography } from "@mui/material";
import { useRequest } from "ahooks";
import { useNavigate } from "react-router-dom";
import SimpleHeader from "@/pages/components/Headers/SimpleHeader.tsx";
import {useTranslation} from "react-i18next";

const TransactionDetail = () => {
  const sn = getUrlParams('sn')
  const navigate = useNavigate();
  const {t} = useTranslation();
  const getDetailReq = useRequest(async () => {
    const res = await axiosInstance.post(API.ASSETS_TRANS_DETAIL, {sn});
    return res
  })

  const _renderIcon = (isCardTrans: boolean) => {
    if (isCardTrans) {
      let icon = getResourceByMccName(getDetailReq?.data?.merchantName);
      let merchantIcon = !!icon;
      if (!icon) icon = getResourceByMcc(getDetailReq?.data?.mcc);
      if (icon) {
        if (merchantIcon) {
          return <img src={icon}/>
        } else {
          return <Box>
            <img src={icon}/>
          </Box>
        }
      } else {
        icon = 'card-info';
      }
      return <Box>
        <RpIcon icon={icon} size={18}/>
      </Box>
    } else {
      const icon = getIconByBizType(getDetailReq?.data?.businessType);
      return <Box>
        {icon ? <RpIcon icon={icon} size={24}/> : <RpIcon icon={"card-consume"} size={24}/>}
      </Box>
    }
  }

  if (!getDetailReq?.data) return null;

  return (<>
    <Stack sx={{width: '100%'}}>
      <SimpleHeader title={t('transaction_detail')} />
      <Stack>
        <Stack sx={{
          padding: '16px',
        }}>
          <Stack direction="row" alignItems="center">
            {_renderIcon(!!getDetailReq?.data?.cardId)}
            <Typography>{getDetailReq?.data?.merchantName}</Typography>
          </Stack>
          <Stack direction="row" alignItems="flex-end">
            <Typography
              sx={theme => ({
                fontFamily: 'Urbanist-bold',
                fontSize: theme.typography.pxToRem(32),
              })}
            >{getDetailReq?.data?.amount}</Typography>
            <Typography>{getDetailReq?.data?.varietyCodeDisplayName}</Typography>
          </Stack>
          
          {/*<TransPaymentInfo record={getDetailReq?.data} />*/}
        </Stack>

        <Divider sx={{borderWidth: '4px'}} />
        <Stack gap='20px' sx={{
          padding: '16px',
        }}>
          <Typography
            sx={theme => ({
              fontFamily: 'Urbanist-bold',
              fontSize: theme.typography.pxToRem(32),
            })}
          >Transaction Details</Typography>
          <Stack>
            <Typography color="textDisabled">Card Number</Typography>
            <Typography>....{getDetailReq?.data?.cardLast4}</Typography>
          </Stack>
          <Stack>
            <Typography color="textDisabled">MCC</Typography>
            <Typography>{getDetailReq?.data?.merchantName}</Typography>
          </Stack>
          <Stack>
            <Typography color="textDisabled">Channel</Typography>
            <Typography>{getDetailReq?.data?.channel}</Typography>
          </Stack>
          <Stack>
            <Typography color="textDisabled">Merchant City</Typography>
            <Typography>{getDetailReq?.data?.address || '--'}</Typography>
          </Stack>
          <Stack>
            <Typography color="textDisabled">Merchant Country</Typography>
            <Typography>{getDetailReq?.data?.Country || '--'}</Typography>
          </Stack>
          <Stack>
            <Typography color="textDisabled">Transaction Date</Typography>
            <Typography>{getDetailReq?.data?.createTime || '--'}</Typography>
          </Stack>
          <Stack>
            <Typography color="textDisabled">Declined Reason</Typography>
            <Typography>{getDetailReq?.data?.createTime || '--'}</Typography>
          </Stack>
          <Stack>
            <Typography color="textDisabled">Transaction ID</Typography>
            <Stack direction="row">
              <Typography>{getDetailReq?.data?.transactionId || '--'}</Typography>
              <CopyButton value={getDetailReq?.data?.transactionId} />
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  </>)
}

export default TransactionDetail;